module.exports = __webpack_public_path__ + "media/images/products/fmt100/fmt100-1-200x200-3f82bcb0ed9eff5e1a7867ff29ff9e78.png";